module.exports = __webpack_public_path__ + "img/shrimp_th_new_0001.af35878d.png";